// Mirror of api/src/pricing.ts for the accept dialog and the admin preview; the server
// recomputes on accept with the prices from the database.
import type { Plan, Pricing, Quote } from './types';

const WEEKS_PER_MONTH = 52 / 12;

const int = (v: unknown, min: number, max: number): number | undefined =>
  typeof v === 'number' && Number.isFinite(v) ? Math.min(max, Math.max(min, Math.round(v))) : undefined;

export const quote = (pricing: Pricing, plan: Plan | null): Quote => {
  const engineers = int(plan?.engineers, 1, 10) ?? 1;
  const monthly = engineers * pricing.engineerMonthly + pricing.teamMonthly;
  const q: Quote = { ...pricing, engineers, monthly };
  const a = int(plan?.weeksMin, 1, 260);
  const b = int(plan?.weeksMax, 1, 260);
  if (a && b) {
    const [lo, hi] = [Math.min(a, b), Math.max(a, b)];
    q.weeks = [lo, hi];
    q.total = [Math.round((monthly * lo) / WEEKS_PER_MONTH), Math.round((monthly * hi) / WEEKS_PER_MONTH)];
  }
  return q;
};

export const brl = (cents: number): string =>
  (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: cents % 100 ? 2 : 0 });

export const quoteLines = (q: Quote): Array<[string, string]> => {
  const lines: Array<[string, string]> = [
    [q.engineers === 1 ? '1 engenheiro' : `${q.engineers} engenheiros`, `${q.engineers} × ${brl(q.engineerMonthly)}/mês`],
    ['Time parcial', `${brl(q.teamMonthly)}/mês`],
    ['Investimento mensal', `${brl(q.monthly)}/mês`],
  ];
  if (q.total && q.weeks) lines.push(['Estimativa total', `${brl(q.total[0])} a ${brl(q.total[1])} (${q.weeks[0]} a ${q.weeks[1]} semanas)`]);
  return lines;
};
